import { newApiInstance } from 'functions/request';

export const fetchRetailer = id => newApiInstance.get(`/retailers/${id}?minimal_offer_rate=0`);
